import React, { useEffect, useState, useCallback, useMemo } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import api from "../../utils/apiAuth";
import AddSkill from "../../components/AddSkill";

const SkillsModal = React.memo(
  ({ initialSkills, options: propOptions, onSkillsUpdate }) => {
    const [options, setOptions] = useState(propOptions || []);
    const [skills, setSkills] = useState(initialSkills || []);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
      setOptions(propOptions || []);
    }, [propOptions]);

    const fetchSkills = useCallback(async () => {
      try {
        const response = await api.get("/skills");
        const skillData = response.data.data || response.data || [];
        if (Array.isArray(skillData)) {
          setOptions(skillData);
        } else {
          console.warn(
            "API'den gelen veri bir dizi değil, varsayılan boş dizi ile devam ediliyor."
          );
          setOptions([]);
        }
      } catch (error) {
        console.error("Yetkinlikler alınırken hata oluştu:", error);
      }
    }, []);

    useEffect(() => {
      if (!propOptions || propOptions.length === 0) {
        fetchSkills();
      }
    }, [propOptions, fetchSkills]);

    const filteredOptions = useMemo(() => {
      return options.filter((option) => {
        const skillName = option.name || option;
        return skillName.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }, [options, searchTerm]);

    const addSkill = useCallback(
      (skillName) => {
        if (!skills.includes(skillName)) {
          const updatedSkills = [...skills, skillName];
          setSkills(updatedSkills);
          onSkillsUpdate(updatedSkills);
        }
      },
      [skills, onSkillsUpdate]
    );

    const removeSkill = useCallback(
      (skillName) => {
        const updatedSkills = skills.filter((name) => name !== skillName);
        setSkills(updatedSkills);
        onSkillsUpdate(updatedSkills);
      },
      [skills, onSkillsUpdate]
    );

    return (
      <div>
        <AddSkill
          options={filteredOptions}
          selectedValues={skills}
          onSelect={addSkill}
          onDeselect={removeSkill}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          placeholder="Yetkinlik ara..."
          label="Becerileri Ekle"
        />
        <div className="flex flex-wrap gap-2 sm:gap-3 mt-4">
          {skills.map((skill) => {
            const skillName = typeof skill === "object" ? skill.name : skill;
            return (
              <button
                key={skillName}
                className="btn-green flex items-center gap-1 sm:gap-2 text-xs sm:text-sm px-2 py-1 sm:px-3 sm:py-2 rounded-md"
                type="button"
                onClick={() => removeSkill(skill)}
              >
                <span>{skillName}</span>
                <span className="text-sm sm:text-base">
                  <IoIosCloseCircle />
                </span>
              </button>
            );
          })}
        </div>
        <input type="hidden" name="skills" value={JSON.stringify(skills)} />
      </div>
    );
  }
);

export default SkillsModal;
